import { inject, Injectable, signal } from '@angular/core';
import { Medarbejder } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejder.model';
import { MedarbejdereDatasource } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejdere.datasource';

@Injectable({
  providedIn: 'root'
})
export class MedarbejdereService  {
  datasource = inject(MedarbejdereDatasource);
  selectedMedarbejder = signal<Medarbejder | undefined>(undefined);
  activeTab = signal('list');
  mode = signal('update');
  searchText = signal('');
  medtagSlettede = signal(false);

  selectMedarbejder(medarbejder: Medarbejder) {
    this.mode.set('update');
    this.selectedMedarbejder.set(medarbejder);

    if (medarbejder) {
      this.activeTab.set('detail');
    }
  }

  opretMedarbejder() {
    this.mode.set('create');
    this.selectedMedarbejder.set(undefined);
    this.activeTab.set('detail');
  }

  onSearch() {
    this.datasource.searchParams.set({
      text: this.searchText(),
      medtagSlettede: this.medtagSlettede()
    });
  }

}
